import { render, staticRenderFns } from "./PlacePresetCard.vue?vue&type=template&id=b57c208a"
import script from "./PlacePresetCard.vue?vue&type=script&lang=js"
export * from "./PlacePresetCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports